import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useInvitationRequestFormState() {
  return useAppState();
}

export function useInvitationRequestFormActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((state) => ({
      ...state,
      invitationRequestForm: {
        firstName: '',
        lastName: '',
        email: '',
        linkedInProfileUrl: '',
        personalWebsiteOrBlogUrl: '',
        expectedUseCases: {
          job_search: false,
          talent_search: false,
          networking: false,
          other: false,
        },
        expectedUseCasesOther: '',
      },
    }));
  }

  function updateFirstName(firstName) {
    dispatch((state) => ({
      ...state,
      invitationRequestForm: {
        ...state.invitationRequestForm,
        firstName,
      },
    }));
  }

  function updateLastName(lastName) {
    dispatch((state) => ({
      ...state,
      invitationRequestForm: {
        ...state.invitationRequestForm,
        lastName,
      },
    }));
  }

  function updateEmail(email) {
    dispatch((state) => ({
      ...state,
      invitationRequestForm: {
        ...state.invitationRequestForm,
        email,
      },
    }));
  }

  function updateLinkedInProfileUrl(linkedInProfileUrl) {
    dispatch((state) => ({
      ...state,
      invitationRequestForm: {
        ...state.invitationRequestForm,
        linkedInProfileUrl,
      },
    }));
  }

  function updatePersonalWebsiteOrBlogUrl(personalWebsiteOrBlogUrl) {
    dispatch((state) => ({
      ...state,
      invitationRequestForm: {
        ...state.invitationRequestForm,
        personalWebsiteOrBlogUrl,
      },
    }));
  }

  function toggleExpectedUseCase(useCase) {
    dispatch((state) => ({
      ...state,
      invitationRequestForm: {
        ...state.invitationRequestForm,
        expectedUseCases: {
          ...state.invitationRequestForm.expectedUseCases,
          [useCase]: !state.invitationRequestForm.expectedUseCases[useCase],
        },
      },
    }));
  }

  function updateExpectedUseCasesOther(expectedUseCasesOther) {
    dispatch((state) => ({
      ...state,
      invitationRequestForm: {
        ...state.invitationRequestForm,
        expectedUseCasesOther,
      },
    }));
  }

  function onResponse(response) {
    dispatch((state) => ({ ...state, ...response }));
  }

  function onError(feedback) {
    dispatch((state) => ({ ...state, ...feedback }));
  }

  function clearFeedback() {
    dispatch((state) => ({
      ...state,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    updateFirstName,
    updateLastName,
    updateEmail,
    updateLinkedInProfileUrl,
    updatePersonalWebsiteOrBlogUrl,
    toggleExpectedUseCase,
    updateExpectedUseCasesOther,
    onResponse,
    onError,
    clearFeedback,
  };
}
